import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import AdminLeftMenu from '../AdminLeftMenu/AdminLeftMenu';
import { AdminLeftMenuItem, adminLeftMenuSelector } from '../AdminLeftMenu/reducers/AdminLeftMenuReducer';
import BulkImportMarketInfo from '../BulkImportMarketInfo/BulkImportMarketInfo';
import BulkImportTonnage from '../BulkImportTonnage/BulkImportTonnage';
import CargoTypeManagement from '../CargoTypeManagement/CargoTypeManagement';
import CheckDuplicate from '../CheckDuplicate/CheckDuplicate';
import DatabaseBackup from '../DatabaseBackup/DatabaseBackup';
import InvalidCheck from '../InvalidCheck/InvalidCheck';
import MarketingEmail from '../MarketingEmail/MarketingEmail';
import MarketingMatchingConfig from '../MarketingMatchingConfig/MarketingMatchingConfig';
import PortManagement from '../PortManagement/PortManagement';
import UserManagement from '../UserManagement/UserManagement';
import './AdminTools.scss';

const AdminTools: React.FunctionComponent = () => {
    const adminLeftMenuData = useSelector(adminLeftMenuSelector);

    return (
        <>
            <Grid container>
                <Grid item lg={2} xs={3}>
                    <AdminLeftMenu>
                    </AdminLeftMenu>
                </Grid>
                <Grid item lg={10} xs={9} className="admin-content">
                    {
                        adminLeftMenuData.selectedMenu == AdminLeftMenuItem.UserManagement &&
                        <>
                            <UserManagement></UserManagement>
                        </>
                    }
                    {
                        adminLeftMenuData.selectedMenu == AdminLeftMenuItem.Port &&
                        <>
                            <PortManagement></PortManagement>
                        </>
                    }
                    {
                        adminLeftMenuData.selectedMenu == AdminLeftMenuItem.DuplicateCheck &&
                        <>
                            <CheckDuplicate></CheckDuplicate>
                        </>
                    }
                    {
                        adminLeftMenuData.selectedMenu == AdminLeftMenuItem.DatabaseBackup &&
                        <>
                            <DatabaseBackup></DatabaseBackup>
                        </>
                    }
                    {
                        adminLeftMenuData.selectedMenu == AdminLeftMenuItem.CargoType &&
                        <>
                            <CargoTypeManagement></CargoTypeManagement>
                        </>
                    }
                    {
                        adminLeftMenuData.selectedMenu == AdminLeftMenuItem.MarketingMatchingConfig &&
                        <>
                            <MarketingMatchingConfig></MarketingMatchingConfig>
                        </>
                    }
                    {
                        adminLeftMenuData.selectedMenu == AdminLeftMenuItem.InvalidCheck &&
                        <>
                            <InvalidCheck></InvalidCheck>
                        </>
                    }
                    {
                        adminLeftMenuData.selectedMenu == AdminLeftMenuItem.BulkImportTonnage &&
                        <>
                            <BulkImportTonnage></BulkImportTonnage>
                        </>
                    }
                    {
                        adminLeftMenuData.selectedMenu == AdminLeftMenuItem.BulkImportMarketInfo &&
                        <>
                            <BulkImportMarketInfo></BulkImportMarketInfo>
                        </>
                    }
                </Grid>
            </Grid>
        </>
    )
};

export default AdminTools;